import SectionHeading from "@/components/feature/SectionHeading";
import { topicItems } from "@/mocks/home";

export default function TopicSection() {
  return (
    <section id="topic" className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="按题材进专区"
          title="话题专区"
          description="同一件事往往不止一条更新，进专区能看到前因后果和补档顺序，比在首页一条条翻更省事。"
        />

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:mt-10">
          {topicItems.map((topic) => (
            <a
              key={topic.id}
              href="#latest"
              className={
                topic.hot
                  ? "group rounded-lg border border-accent-300 bg-accent-100 p-4 transition-colors hover:border-accent-400 md:p-5"
                  : "group rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
              }
            >
              <div className="flex items-start justify-between gap-2">
                <span className="font-heading text-base font-semibold text-foreground-950">
                  {topic.name}
                </span>
                {topic.hot ? (
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary-600">
                    <i className="ri-fire-fill"></i>
                  </span>
                ) : (
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400 transition-colors group-hover:text-primary-500">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                )}
              </div>
              <p className="mt-2 text-xs text-foreground-600">{topic.count}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}